document.addEventListener('DOMContentLoaded', () => {
    const urlPathname = window.location.pathname.split('/products/')[1].split('/')[0];
    // borrar en X dias
    localStorage.removeItem(`bundle-${urlPathname}`);

    const orders = JSON.parse(localStorage.getItem(`bundle-${urlPathname}`));
    if (orders) {
        renderOrderList();
        // renderTotalQuantity();
    }
});
function handleOrderVisibility() {
    const urlPathname = window.location.pathname.split('/products/')[1].split('/')[0];
    const orders = JSON.parse(localStorage.getItem(`bundle-${urlPathname}`));
    const orderList = document.querySelector('.build-your-pack-order__order-list');
    const orderContainer = document.getElementById('buildYourPack--order');

    if (orders && orders.length > 0) {
        orderContainer.classList.remove('hidden');
    } else {
        orderContainer.classList.add('hidden');
    }
}

function renderOrderList() {
    const urlPathname = window.location.pathname.split('/products/')[1].split('/')[0];
    const ordersKey = `bundle-${urlPathname}`;
    const orders = JSON.parse(localStorage.getItem(ordersKey)) || [];
    const orderListContainer = document.querySelector('.build-your-pack-order__order-list__list');
    const orderContainer = document.getElementById('buildYourPack--order');
    const productListContainer = document.querySelector('.build-your-pack-order__order-list__add-to-cart-list');

    orderListContainer.innerHTML = '';
    productListContainer.innerHTML = '';

    const productCards = document.querySelectorAll('.build-your-pack__collection-product__product-card');

    productCards.forEach(card => {
        const variantId = card.getAttribute('data-variant-id');
        const addToOrderButton = card.querySelector('.add-to-order');
        const removeToOrderButton = card.querySelector('.remove-to-order');
        const fromCollection = card.getAttribute('data-from-collection');
        const maxQtyPerCollection = parseInt(card.closest('.build-your-pack__collection').getAttribute('data-max-qty'));

        const collectionCount = orders
            .filter(order => order.fromCollection === fromCollection)
            .reduce((sum, order) => sum + order.quantity, 0);

        const isInOrder = orders.some(order => order.id === variantId);

        if (collectionCount < maxQtyPerCollection) {
            if (addToOrderButton) addToOrderButton.classList.remove('hidden');
        } else {
            if (addToOrderButton) addToOrderButton.classList.add('hidden');
        }

        if (isInOrder) {
            if (removeToOrderButton) removeToOrderButton.classList.remove('hidden');
        } else {
            if (removeToOrderButton) removeToOrderButton.classList.add('hidden');
        }
    });

    if (orders.length > 0) {
        orderContainer.classList.remove('hidden');
    }

    orders.forEach((product) => {
        const productElement = document.createElement('div');
        productElement.classList.add('build-your-pack-order__order-list__product');

        const productInfoContainer = document.createElement('div');
        productInfoContainer.classList.add('product-info-container');

        const productTitleContainer = document.createElement('div');
        const productTitleElement = document.createElement('span');
        productTitleElement.textContent = product.title;
        productTitleElement.classList.add('product-title');

        const productQuantity = document.createElement('span');
        productQuantity.textContent = product.quantity + 'x';
        productQuantity.classList.add('product-quantity');

        const productPrice = document.createElement('span');
        productPrice.textContent = product.price;
        productPrice.classList.add('product-price');

        const productRemove = document.createElement('span');
        productRemove.textContent = window.bundlesStrings.remove;
        productRemove.classList.add('product-remove');

        productRemove.addEventListener('click', () => {
            const indexToRemove = orders.findIndex(item => item.id === product.id);

            if (indexToRemove !== -1) {
                orders.splice(indexToRemove, 1);
                localStorage.setItem(ordersKey, JSON.stringify(orders));
                renderOrderList();
                updateBundleAddToCartButton();
            }
        });

        productTitleContainer.appendChild(productQuantity);
        productTitleContainer.appendChild(productTitleElement);
        productTitleContainer.appendChild(productRemove);
        productTitleContainer.appendChild(productPrice)

        productListContainer.appendChild(productTitleContainer);

        const productImageElement = document.createElement('img');
        productImageElement.src = product.image;
        productImageElement.alt = product.title;
        productImageElement.title = product.title;
        productImageElement.classList.add('product-image');

        productInfoContainer.appendChild(productImageElement);
        productElement.appendChild(productInfoContainer);

        orderListContainer.appendChild(productElement);
    });

    const totalMaxQty = [...document.querySelectorAll('.build-your-pack__collection')]
        .reduce((sum, slot) => sum + (parseInt(slot.getAttribute('data-max-qty')) || 0), 0);

    const emptySlots = totalMaxQty - orders.length;
    for (let i = 0; i < emptySlots; i++) {
        const emptyCardElement = document.createElement('div');
        emptyCardElement.classList.add('build-your-pack-order__order-list__product', 'empty-product');

        const iconPlusElement = document.createElement('span');
        iconPlusElement.classList.add('price-icon');

        const iconPlus = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        iconPlus.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
        iconPlus.setAttribute('aria-hidden', 'true');
        iconPlus.setAttribute('focusable', 'false');
        iconPlus.setAttribute('class', 'icon icon-plus');
        iconPlus.setAttribute('fill', 'none');
        iconPlus.setAttribute('viewBox', '0 0 10 10');

        const pathElementPlus = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        pathElementPlus.setAttribute('fill-rule', 'evenodd');
        pathElementPlus.setAttribute('clip-rule', 'evenodd');
        pathElementPlus.setAttribute(
            'd',
            'M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1'
        );
        pathElementPlus.setAttribute('fill', 'currentColor');
        iconPlus.appendChild(pathElementPlus);
        iconPlusElement.appendChild(iconPlus);

        emptyCardElement.appendChild(iconPlusElement);
        orderListContainer.appendChild(emptyCardElement);
    }

    handleOrderVisibility();
}


function addToOrder(event) {
    const itemsBundly = document.querySelectorAll('.bundly__component_grid_item');
    const card = event.target.closest('.build-your-pack__collection-product__product-card');
    const image = card.getAttribute('data-product-image');
    const type = card.getAttribute('data-product-type');
    const variantId = card.getAttribute('data-variant-id');
    const productTitle = card.getAttribute('data-product-title');
    const productVariantTitle = card.getAttribute('data-variant-title');
    const price = card.getAttribute('data-price');
    const priceWithoutCurrency = card.getAttribute('data-price-without-currency');
    const fromCollection = card.getAttribute('data-from-collection');
    const maxQtyPerCollection = parseInt(card.closest('.build-your-pack__collection').getAttribute('data-max-qty'));
    const totalInventory = event.target.closest('.add-to-order').getAttribute("data-inventory");
    const usedInventory = event.target.closest('.add-to-order').getAttribute("data-qty");

    itemsBundly.forEach((item) => {
        
        const itemBundly = item.querySelector('script')?.textContent;
        const parsedContent = JSON.parse(itemBundly);
        
        if(parsedContent[0].name.includes(productTitle)) {
            item.querySelector('.bundly__product_option_value label').click();

            const productInfo = {
                id: variantId,
                image,
                type,
                title: productTitle,
                variantTitle: productVariantTitle,
                price: price,
                priceWithoutCurrency: priceWithoutCurrency,
                quantity: 1,
                fromCollection,
                maxQty: maxQtyPerCollection,
                totalInventory: totalInventory,
                usedInventory: usedInventory
            };
        
            const urlPathname = window.location.pathname.split('/products/')[1].split('/')[0];
            let orders = JSON.parse(localStorage.getItem(`bundle-${urlPathname}`)) || [];
        
            const collectionCount = orders
                .filter(item => item.fromCollection === fromCollection)
                .reduce((sum, item) => sum + item.quantity, 0);
        
            if (collectionCount >= maxQtyPerCollection) {
                console.log(`No puedes añadir más productos a la colección ${fromCollection}. Máximo permitido: ${maxQtyPerCollection}`);
                return;
            }
        
            orders.push(productInfo);
        
            localStorage.setItem(`bundle-${urlPathname}`, JSON.stringify(orders));
            renderOrderList();
            updateBundleAddToCartButton();
        }
    })

}





function removeToOrder(event) {
    const card = event.target.closest('.build-your-pack__collection-product__product-card');
    const variantId = card.getAttribute('data-variant-id');
    const urlPathname = window.location.pathname.split('/products/')[1].split('/')[0];

    let orders = JSON.parse(localStorage.getItem(`bundle-${urlPathname}`)) || [];
    const indexToRemove = orders.findIndex(item => item.id === variantId);

    if (indexToRemove !== -1) {
        orders.splice(indexToRemove, 1);
        const remainingItems = orders.filter(item => item.id === variantId);
        localStorage.setItem(`bundle-${urlPathname}`, JSON.stringify(orders));
        renderOrderList();

        updateBundleAddToCartButton();
        if (remainingItems.length === 0) {
            event.target.classList.add('hidden');
            if(event.target.previousElementSibling.classList.contains('hidden')) {
                event.target.previousElementSibling.classList.remove('hidden');
            }
        }
    }
}



// Función que se ejecuta para añadir los productos al carrito
function addOrderToCart() {
    const urlPathname = window.location.pathname.split('/products/')[1].split('/')[0];
    const products = JSON.parse(localStorage.getItem(`bundle-${urlPathname}`));

    if (!products || products.length === 0) {
        console.error('No hay productos en el carrito.');
        return;
    }

    try {
        const reversedProducts = products.reverse();

        const items = reversedProducts.map((product) => {
            const { id, quantity } = product;
            return { id, quantity };
        });

        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        const formData = {
            items,
            sections: cart.getSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname,
        };

        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Error al agregar producto al carrito');
                }
                return response.json();
            })
            .then((data) => {
                fetch(`${routes.cart_url}?section_id=cart-drawer`)
                    .then((response) => response.text())
                    .then((responseText) => {
                        const html = new DOMParser().parseFromString(responseText, 'text/html');
                        const sourceQty = html.querySelector('.drawer__inner');
                        document.querySelector('cart-drawer').classList.remove('is-empty');
                        document.querySelector('.drawer__inner').innerHTML = sourceQty.innerHTML;
                        if (localStorage.getItem('__ui')) localStorage.removeItem('__ui');

                        // const cartBubble = document.querySelector('.cart-count-bubble');
                        // cartBubble?.classList.remove('hidden');
                        // const totalQuantity = data.items.reduce((total, item) => {
                        //     return total + item.quantity;
                        // }, 0);
                        // cartBubble.querySelector('span[aria-hidden="true"]').innerText = totalQuantity;
                        cart.open();
                        localStorage.removeItem(`bundle-${urlPathname}`);
                        renderOrderList();
                    })
                    .catch((e) => {
                        console.error(e);
                    });
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    } catch (error) {
        console.error('Error:', error);
    }
}

// Función para actualizar el botón según el estado del carrito
function updateBundleAddToCartButton() {
    const urlPathname = window.location.pathname.split('/products/')[1].split('/')[0];
    const orders = JSON.parse(localStorage.getItem(`bundle-${urlPathname}`)) || [];
    const bundleAddToCartButton = document.getElementById('bundle-add-to-cart');

    const collectionCounts = orders.reduce((acc, order) => {
        acc[order.fromCollection] = (acc[order.fromCollection] || 0) + order.quantity;
        return acc;
    }, {});

    const collections = [...document.querySelectorAll('.build-your-pack__collection')];

    // if (orders.length === 1) {
    //     bundleAddToCartButton.textContent = window.bundlesStrings.two_charms;
    //     bundleAddToCartButton.onclick = function (event) {
    //         event.preventDefault();
    //         document.getElementById('build-your-pack-step-2').scrollIntoView({ behavior: 'smooth' });
    //         console.log('test2');
    //     };
    //     bundleAddToCartButton.style.backgroundColor = '#fff';
    //     bundleAddToCartButton.style.color = '#000';
    // } else if (orders.length === 3) {
    //     bundleAddToCartButton.textContent = window.bundlesStrings.add_to_cart;
    //     bundleAddToCartButton.style.backgroundColor = '#000';
    //     bundleAddToCartButton.style.color = '#fff';
        
    // } else if (orders.length > 1 && orders.length < 3) {
    //     bundleAddToCartButton.textContent = window.bundlesStrings.second_charm;

    //     const canAddSecondProduct = collections.every(collection => {
    //         const maxQty = parseInt(collection.getAttribute('data-max-qty')) || 0;
    //         const collectionId = collection.getAttribute('id');
    //         const currentCollectionCount = collectionCounts[collectionId] || 0;
    //         return currentCollectionCount < maxQty;
    //     });
    // }
}

function addToCartFunction() {
    const urlPathname = window.location.pathname.split('/products/')[1].split('/')[0];


    document.querySelector('.bundly__add_to_cart_button').click();
    localStorage.removeItem(`bundle-${urlPathname}`);

    const checkExist = setInterval(function() {
        const warnings = document.querySelectorAll('.bundly__button_warning')[0];
        
        if (warnings) {
          const listItems = document.querySelector('.build-your-pack-order-container');
          const warningMessage = document.createElement('span');
          warningMessage.classList.add('warning-message');
          warningMessage.innerHTML = warnings.innerHTML;
          listItems.insertBefore(warningMessage, listItems.firstChild);
          clearInterval(checkExist);
        }
      }, 100);

      setTimeout(() => {
        document.querySelector('.warning-message').remove()
      }, 500)
}


// Llamar a la función para actualizar el botón cuando se cargue la página
document.addEventListener('DOMContentLoaded', updateBundleAddToCartButton);